// 🎓 Familles de niveaux (tour 40) : chaque niveau de l'admin peut avoir une famille (Collège,
// Lycée, Prépa, Supérieur, Adultes), mêmes clés que l'API (app/helper/LevelFamilies.js). Nouveau
// design : l'accueil et la recherche proposent les familles (choisir une famille, c'est chercher
// tous ses niveaux), les cartes et les fiches affichent les familles, avec le détail des niveaux
// seulement si on le demande. Un niveau sans famille reste proposé et affiché seul.
export const FAMILIES = ["college", "lycee", "prepa", "superieur", "adultes"];
const PREFIX = "famille:";

const isFamily = (family) => FAMILIES.includes(family);
export const gradeName = (g, language) => (language === "en" ? g?.grade_name || g?.grade_name_fr : g?.grade_name_fr || g?.grade_name) || "";
export const familyLabel = (family, t) => t(`nd.families.${family}`);

// 🙈 Niveau masqué dans l'admin (tour 42) : affiché nulle part. L'API ne l'envoie plus, sauf au prof
// qui ouvre sa propre annonce (marqué « hidden », pour « Modifier l'annonce »)
export const visibleGrades = (grades) => (Array.isArray(grades) ? grades : []).filter((g) => g && g.hidden !== true);

// 🎓 Niveau préféré de l'élève (tour 42) : l'API garde le nom anglais du niveau (« Year 7 »), ou
// un nom français pour un ancien compte. Le niveau visible de la liste qui porte ce nom, null sinon
// (niveau masqué ou qui n'existe plus : rien n'est affiché).
export const gradeOfPreference = (stored, grades = []) => {
  const name = String(stored || "").trim();
  return name ? visibleGrades(grades).find((g) => g?.grade_name === name || g?.grade_name_fr === name) || null : null;
};

// Choix du menu « Niveau » : les familles qui ont au moins un niveau, puis les niveaux sans
// famille. Aucune famille choisie dans l'admin : les niveaux seuls, comme avant
export const levelChoices = (all = [], t, language) => {
  const grades = visibleGrades(all);
  return [
    ...FAMILIES.filter((f) => grades.some((g) => g?.family === f)).map((f) => ({ value: PREFIX + f, label: familyLabel(f, t) })),
    ...grades.filter((g) => !isFamily(g?.family)).map((g) => ({ value: String(g._id), label: gradeName(g, language) })),
  ];
};

// Famille qui a au moins un niveau visible (tour 42) : sinon elle n'apparaît nulle part, et elle
// revient d'elle-même dès qu'un niveau visible la reçoit dans l'admin
export const familyHasLevels = (grades = [], family) => isFamily(family) && visibleGrades(grades).some((g) => g?.family === family);

// Valeur du menu ↔ recherche : une famille ou un niveau précis
export const parseLevelChoice = (value) => {
  const v = String(value || "");
  return v.startsWith(PREFIX) && isFamily(v.slice(PREFIX.length)) ? { levelId: null, family: v.slice(PREFIX.length) } : { levelId: v || null, family: null };
};
export const levelChoiceOf = ({ levelId, family } = {}) => (isFamily(family) ? PREFIX + family : levelId || "");

// Niveaux d'une annonce groupés : familles dans leur ordre (avec leurs niveaux), puis chaque niveau
// sans famille, seul. [{ key, label, levels: [noms] }]
export const groupByFamily = (all = [], t, language) => {
  const grades = visibleGrades(all);
  const groups = FAMILIES.map((f) => ({ key: f, label: familyLabel(f, t), levels: grades.filter((g) => g?.family === f).map((g) => gradeName(g, language)).filter(Boolean) })).filter((g) => g.levels.length);
  const alone = grades.filter((g) => !isFamily(g?.family)).map((g) => ({ key: String(g?._id || gradeName(g, language)), label: gradeName(g, language), levels: [] })).filter((g) => g.label);
  return [...groups, ...alone];
};
